/* eslint-disable @typescript-eslint/no-explicit-any */
import {colorCodes} from 'definitions/constant'
import {formatBytes, formatTransactions} from 'utils'

export const minutesToHour = 60
export const secondsToHour = 3600
export const DopeOthers = 'Dope#Others'
export const OtherCategories = 'Other Categories'

export const sizesInString = {
  Bytes: 'Bytes',
  KB: 'Kilobytes',
  MB: 'Megabytes',
  GB: 'Gigabytes',
  TB: 'Terabytes',
  PB: 'Petabytes',
  EB: 'Exabytes',
  ZV: 'Zettabytes',
  YB: 'Yottabytes',
}

export const Top_Activity = 'Top Activity'

const emptyData1 = {
  y: 100,
  color: colorCodes.gray800,
}

const emptyData2 = {
  y: 100,
  color: colorCodes.gray1500,
}

export const outerSize_max = 240
export const innerSize_max = 190
export const outerSize_min = 190
export const innerSize_min = 140

export const donutChartOuterRingColors = [
  colorCodes.red1000,
  colorCodes.blueDark,
  colorCodes.purple500,
  colorCodes.yellow100,
  colorCodes.green1200,
]
export const donutChartInnerRingColors = [
  colorCodes.red1100,
  colorCodes.cyanDark,
  colorCodes.purple50,
  colorCodes.yellow1000,
  colorCodes.green100,
]

export const barChartColors = [
  colorCodes.purple500,
  colorCodes.purple50,
  colorCodes.purple400,
  colorCodes.gray1200,
]
export const topCategories = 'Top Categories'
export const barChartCategoriesCount = barChartColors.length

const emptyHaloState = {
  hover: {
    halo: {
      size: 0,
    },
  },
}

export const emptyDoubleDonutChartSeries = [
  {
    innerSize: innerSize_max,
    size: outerSize_max,
    name: '',
    data: [emptyData1],
    states: emptyHaloState,
  },
  {
    innerSize: innerSize_min,
    size: outerSize_min,
    name: '',
    data: [emptyData2],
    states: emptyHaloState,
  },
]

export const doubleDonutChartRawOptions = {
  chart: {
    type: 'pie',
    animation: true,
    backgroundColor: colorCodes.dopeBlack,
    margin: [0, 5, 10, 5],
    spacingTop: 0,
    spacingBottom: 0,
    spacingLeft: 0,
    spacingRight: 0,
  },
  credits: {
    enabled: false,
  },
  title: {
    text: '--',
    align: 'center',
    verticalAlign: 'middle',
    style: {
      color: colorCodes.white,
      fontWeight: 'bold',
      fontSize: '32px',
      fontFamily: 'ABC-Bold',
    },
    y: 25,
  },
  subtitle: {
    text: '--',
    align: 'center',
    verticalAlign: 'middle',
    style: {
      color: colorCodes.white,
      fontWeight: 'normal',
      fontSize: '12px',
      fontFamily: 'Karla',
    },
    y: 28,
  },
  plotOptions: {
    pie: {
      borderWidth: 0,
    },
    series: {
      slicedOffset: 0,
      animation: false,
      dataLabels: {
        enabled: false,
      },
    },
  },
  tooltip: {
    enabled: false,
  },
  series: emptyDoubleDonutChartSeries,
  drilldown: {
    series: [],
  },
}

export const doubleDonutChartDataOptions = (
  donutchartClickHandler: any,
  title: string = '',
  subtitle: string = '',
  series?: any,
) => {
  return {
    chart: {
      type: 'pie',
      animation: true,
      backgroundColor: colorCodes.dopeBlack,
      plotShadow: false,
      margin: [0, 5, 10, 5],
      spacingTop: 0,
      spacingBottom: 0,
      spacingLeft: 0,
      spacingRight: 0,
      events: {
        drilldown: function (e: any) {
          donutchartClickHandler(e)
        },
      },
    },
    credits: {
      enabled: false,
    },
    title: {
      text: title,
      align: 'center',
      verticalAlign: 'middle',
      style: {
        color: colorCodes.white,
        fontWeight: 'bold',
        fontSize: '32px',
        fontFamily: 'ABC-Bold',
      },
      y: 25,
    },
    subtitle: {
      text: subtitle,
      align: 'center',
      verticalAlign: 'middle',
      style: {
        color: colorCodes.white,
        fontWeight: 'normal',
        fontSize: '12px',
        fontFamily: 'Karla',
      },
      y: 28,
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: 'pointer',
        borderWidth: 0,
        dataLabels: {
          connectorColor: colorCodes.white,
          connectorShape: 'straight',
          distance: 10,
          crookDistance: '70%',
          alignTo: 'connectors',
        },
      },
      series: {
        animation: true,
        slicedOffset: 0,
        dataLabels: {
          enabled: false,
          useHTML: true,
          formatter: function () {
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const self: any = this
            return `<div data-cy='donut-label-${(
              self?.point?.categoryName ||
              self?.point?.domainName ||
              ''
            ).toLowerCase()}-${self?.point?.index}' class='text-white'>
              <div data-cy='donut-label-name' class='text-base font-bold karla-bold no-underline productivity-donut-chart-label'>${
                self?.point?.categoryName ||
                self?.point?.domainName ||
                'Loading...'
              }</div>
              <p class='text-xs font-normal karla '>
                <span>${formatBytes(self?.point?.dataConsumed) || ''}</span>
                <span class='text-gray-500'> | ${
                  formatTransactions(self?.point?.noOfTransactions) || 0
                } Transactions</span>
              </p>
            </div>
            `
          },
        },
        point: {},
        events: {
          mouseOut: function () {
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const self: any = this
            self.chart.title.attr({
              text: title,
            })
            self.chart.subtitle.attr({
              text: subtitle,
            })
          },
        },
      },
    },
    tooltip: {
      enabled: true,
      useHTML: true,
      outside: true,
      backgroundColor: colorCodes.gray1400,
      borderWidth: 0,
      shadow: false,
      style: {
        color: colorCodes.white,
        fontFamily: 'Karla, sans-serif',
        fontWeight: 'bold',
        zIndex: 100,
      },
      formatter(e: any) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const self: any = this
        // hide tooltip for other category or other domain
        const _name = self?.point?.categoryName || self?.point?.domainName
        if (_name === 'Other' || _name === 'Other Domains') {
          return false
        }

        e.chart.title.attr({
          text: self?.point?.bandwidthConsumed || '',
        })
        e.chart.subtitle.attr({
          text: 'Total Bandwidth',
        })

        const tooltipListArray = self?.point?.domains || self?.point?.users
        const tooltipList = () => {
          return `<p class="pt-2">${
            tooltipListArray &&
            tooltipListArray
              .map((listObject: any) => {
                // For domains
                // Else part for Users
                if (listObject.domainName) {
                  if (listObject.domainName !== 'Other Domains') {
                    return `<div class="karla">
                      ${listObject.domainName || listObject.name}
                      </div>`
                  } else {
                    return ''
                  }
                } else {
                  return `<div class="karla">
                      <span>${listObject.domainName || listObject.name}</span>
                      <span class='text-gray-500'> |  ${formatBytes(
                        listObject.dataConsumed,
                      )}</span>
                      </div>`
                }
              })
              .join('')
          } </p>`
        }

        const toolTipTitle = self?.point?.categoryName
          ? 'Top Domains'
          : 'Top Users'
        return `
        <div data-cy='stream-tooltip-${(
          self?.point?.categoryName ||
          self?.point?.domainName ||
          ''
        ).toLowerCase()}-${self?.point?.index}' class='text-white'>
          <div class='text-base karla-bold font-bold'>${toolTipTitle}</div>
          ${tooltipList()}
        </div>
        `
      },
    },
    series: series,
  }
}

export const Week = 'Week'
export const Day = 'Day'

export const weekBarChartCategory = ['-', '-', '-', '-', '-', '-', '-']
export const dayBarChartCategory = [
  '12am',
  '1am',
  '2am',
  '3am',
  '4am',
  '5am',
  '6am',
  '7am',
  '8am',
  '9am',
  '10am',
  '11am',
  '12pm',
  '1pm',
  '2pm',
  '3pm',
  '4pm',
  '5pm',
  '6pm',
  '7pm',
  '8pm',
  '9pm',
  '10pm',
  '11pm',
  '12am',
]

const emptyWeekBarChartData = [
  {y: 0, name: ''},
  {y: 0, name: ''},
  {y: 0, name: ''},
  {y: 0, name: ''},
  {y: 0, name: ''},
  {y: 0, name: ''},
  {y: 0, name: ''},
]
export const emptyWeekBarChartSeries = [
  {
    name: '',
    data: emptyWeekBarChartData,
    color: colorCodes.dopeBlack,
  },
  {
    name: '',
    data: emptyWeekBarChartData,
    color: colorCodes.dopeBlack,
  },
  {
    name: '',
    data: emptyWeekBarChartData,
    color: colorCodes.dopeBlack,
  },
  {
    name: '',
    data: emptyWeekBarChartData,
    color: colorCodes.dopeBlack,
  },
]

const emptyDayBarChartData = [
  {y: 0, name: ''},
  {y: 0, name: ''},
  {y: 0, name: ''},
  {y: 0, name: ''},
  {y: 0, name: ''},
  {y: 0, name: ''},
  {y: 0, name: ''},
  {y: 0, name: ''},
  {y: 0, name: ''},
  {y: 0, name: ''},
  {y: 0, name: ''},
  {y: 0, name: ''},
  {y: 0, name: ''},
  {y: 0, name: ''},
  {y: 0, name: ''},
  {y: 0, name: ''},
  {y: 0, name: ''},
  {y: 0, name: ''},
  {y: 0, name: ''},
  {y: 0, name: ''},
  {y: 0, name: ''},
  {y: 0, name: ''},
  {y: 0, name: ''},
  {y: 0, name: ''},
]

export const emptyDayBarChartSeries = [
  {
    name: '',
    data: emptyDayBarChartData,
    color: colorCodes.dopeBlack,
  },
  {
    name: '',
    data: emptyDayBarChartData,
    color: colorCodes.dopeBlack,
  },
  {
    name: '',
    data: emptyDayBarChartData,
    color: colorCodes.dopeBlack,
  },
  {
    name: '',
    data: emptyDayBarChartData,
    color: colorCodes.dopeBlack,
  },
]

export const barChartRawOptions = {
  chart: {
    type: 'column',
    backgroundColor: colorCodes.dopeBlack,
    marginLeft: 60,
    marginRight: 10,
    spacingLeft: 0,
    spacingRight: 0,
  },
  exporting: {
    enabled: false,
  },
  credits: {
    enabled: false,
  },
  title: {
    text: '',
  },
  xAxis: {
    categories: weekBarChartCategory,
    labels: {
      style: {
        color: colorCodes.white,
        fontWeight: 'bold',
        fontSize: '14px',
        fontFamily: 'Karla',
      },
    },
    lineWidth: 0,
  },
  yAxis: {
    min: 0,
    gridLineWidth: 1,
    gridZIndex: 10,
    gridLineDashStyle: 'Dot',
    reversedStacks: false,
    minPadding: 0,
    maxPadding: 0,
    labels: {
      style: {
        color: colorCodes.white,
        fontWeight: 'normal',
        fontSize: '12px',
        fontFamily: 'ABC Regular',
      },
      formatter: function () {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const self: any = this
        const label = self.axis.defaultLabelFormatter.call(this)
        const extractNoOfBytes = Number(String(label)?.split(' ')?.join(''))
        const noOfBytes = isNaN(extractNoOfBytes) ? 0 : extractNoOfBytes
        const formatValue = formatBytes(noOfBytes, 0)
        return formatValue
      },
    },
    plotLines: [
      {
        color: 'white',
        value: 4,
        width: 1,
        dashStyle: 'Dot',
        label: {
          text: 'Avg',
          x: -35,
          y: 0,
          style: {
            color: colorCodes.gray1100,
            fontWeight: 'normal',
            fontSize: '12px',
            fontFamily: 'ABC Regular',
          },
        },
        zIndex: 10,
      },
    ],
    title: {
      text: '',
    },
    tickPositions: [0, 8],
  },
  legend: {
    align: 'center',
    color: colorCodes.white,
    symbolWidth: 16,
    symbolHeight: 8,
    symbolRadius: 4,
    squareSymbol: false,
    verticalAlign: 'bottom',
    floating: false,
    itemStyle: {
      color: colorCodes.white,
      fontWeight: 'normal',
      fontSize: '10px',
      fontFamily: 'Karla',
    },
    itemHoverStyle: {
      color: colorCodes.white,
    },
    itemHiddenStyle: {
      color: '#444',
    },
    shadow: false,
  },
  tooltip: {
    outside: true,
    backgroundColor: colorCodes.gray1400,
    borderWidth: 0,
    shadow: false,
    style: {
      color: colorCodes.white,
      fontFamily: 'Karla, sans-serif',
      fontWeight: 'bold',
      zIndex: 40,
    },
    useHTML: true,
    formatter: function () {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const self: any = this
      return `
        <div class='text-white productivity-bar-chart-tooltip' id='screen-time-tooltip-${(
          self.point.name || ''
        ).toLowerCase()}-${self.point.index}'>
          <div class='text-base font-bold'>${self.point.name}</div>
          <p class='text-xs font-normal'>
            <span>${self?.point?.dataConsumedText} Transactions</span>
          </p>
        </div>
        `
    },
  },
  plotOptions: {
    column: {
      stacking: 'normal',
      dataLabels: {
        enabled: false,
      },
    },
    series: {
      pointWidth: 40,
      borderWidth: 0,
    },
  },
  series: emptyWeekBarChartSeries,
}

export const dayBarChartRawOptions = {
  plotOptions: {
    ...barChartRawOptions.plotOptions,
    series: {
      ...barChartRawOptions.plotOptions.series,
      pointWidth: 19,
    },
  },
  xAxis: {
    ...barChartRawOptions.xAxis,
    tickInterval: 6,
    categories: dayBarChartCategory,
  },
  yAxis: {
    ...barChartRawOptions.yAxis,
    title: {
      ...barChartRawOptions.yAxis.title,
      x: 25,
    },
    tickPositions: [0, 1],
    plotLines: [
      {
        color: 'white',
        value: 0.5,
        width: 1,
        dashStyle: 'Dot',
        label: {
          text: 'Avg',
          x: -30,
          y: 0,
          style: {
            color: colorCodes.gray1100,
            fontWeight: 'normal',
            fontSize: '12px',
            fontFamily: 'ABC Regular',
          },
        },
        zIndex: 10,
      },
    ],
  },
  series: emptyDayBarChartSeries,
}

export const weekBarChartRawOptions = {
  ...barChartRawOptions,
  plotOptions: {
    ...barChartRawOptions.plotOptions,
    series: {
      ...barChartRawOptions.plotOptions.series,
      pointWidth: 70,
    },
  },
  xAxis: {
    ...barChartRawOptions.xAxis,
    tickInterval: 1,
    categories: weekBarChartCategory,
  },
  yAxis: {
    ...barChartRawOptions.yAxis,
    plotLines: [
      {
        color: 'white',
        value: 4,
        width: 1,
        dashStyle: 'Dot',
        label: {
          text: 'Avg',
          x: -35,
          y: 0,
          style: {
            color: colorCodes.gray1100,
            fontWeight: 'normal',
            fontSize: '12px',
            fontFamily: 'ABC Regular',
          },
        },
        zIndex: 10,
      },
    ],
  },
  series: emptyWeekBarChartSeries,
}
